module.exports = __webpack_public_path__ + "media/svg/gg-b08bf450.svg";